import {CircularProgress, Stack, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store';
import * as Constant from "../models/Constants";
import { useNavigate } from "react-router-dom";

type DashboardMainTopNavbarProps = {
    userId: any;
    title?:string;
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const DashboardMainTopNavbar = (props: DashboardMainTopNavbarProps) => {
    //#region Fields
    const {
        userId,
    } = props

    const refDivHeader = useRef<any>(null)

    const [loadingFlag, setLoadingFlag] = useState(false);
    //#endregion

    return (
        <>
            {loadingFlag && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <div ref={refDivHeader} style={{width:"100%",display:"flex", flexWrap:"nowrap", justifyContent:"space-between", alignItems: 'center', background: Constant.MAIN_HEADER_COLOR,borderBottom: '1px solid #cccfcd'}}>
                    <Stack display={"flex"} flexDirection={"row"}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',width:"250px", marginLeft:"4px", height:"50px" }}>
                             <Typography sx={{color:Constant.CONTENT_COLOR, fontSize:25, fontWeight:"bold"}}>ストレス耐性テスト</Typography>
                        </div>
                    </Stack>
            </div>
        </>
    );
};


const mapStateToProps = (state: ApplicationState) => {
    return {
      
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DashboardMainTopNavbar);